import { ChildMachineConfig } from "../../../../../types";
import { PriceFreezeLoadingState, AirPriceFreezeOfferState } from "./types";
import { ActionTypes } from "./actions";
import { ServiceTypes } from "./services";
import { PriceFreezeOfferEvent } from "./events";

export const getPriceFreezeOfferMachine = (config: ChildMachineConfig) => ({
  initial: PriceFreezeLoadingState.fetchTripDetails,
  states: {
    [PriceFreezeLoadingState.fetchTripDetails]: {
      invoke: {
        src: ServiceTypes.fetchTripDetails,
        onDone: {
          actions: ActionTypes.setTripDetails,
          target: `${PriceFreezeLoadingState.fetchOfferData}`,
        },
        onError: {
          target: `${AirPriceFreezeOfferState.error}`,
        },
      },
    },
    [PriceFreezeLoadingState.fetchOfferData]: {
      invoke: {
        src: ServiceTypes.fetchOfferData,
        onDone: {
          actions: ActionTypes.setPriceFreezeOfferData,
          target: `${AirPriceFreezeOfferState.selectCustomOfferDuration}`,
        },
        onError: {
          target: `${AirPriceFreezeOfferState.error}`,
        },
      },
    },
    [AirPriceFreezeOfferState.selectCustomOfferDuration]: {
      invoke: {
        src: ServiceTypes.createCustomOffer,
        onDone: {
          actions: ActionTypes.setPriceFreezeOffer,
          target: `${AirPriceFreezeOfferState.customOfferGenerated}`,
        },
        onError: {
          target: `${AirPriceFreezeOfferState.error}`,
        },
      },
    },
    [AirPriceFreezeOfferState.customOfferGenerated]: {},
    [AirPriceFreezeOfferState.error]: {},
  },
  on: {
    [PriceFreezeOfferEvent.SET_PRICE_FREEZE_DURATION_INDEX]: {
      actions: [
        ActionTypes.setPriceFreezeDurationIndex,
        ActionTypes.resetPriceFreezeOffer,
      ],
      target: `.${AirPriceFreezeOfferState.selectCustomOfferDuration}`,
    },
    [PriceFreezeOfferEvent.SET_CONTACT_INFO]: {
      actions: ActionTypes.setContactInfo,
    },
    [PriceFreezeOfferEvent.SET_PASSENGER_MAP]: {
      actions: ActionTypes.setPassengerMap,
      target: `.${AirPriceFreezeOfferState.selectCustomOfferDuration}`,
    },
    [PriceFreezeOfferEvent.NEXT]: {
      actions: ActionTypes.addPriceFreezeProduct,
      target: config.nextState,
    },
  },
});
